import {Pressable} from 'react-native';
import Circle from '@/components/web/Circle.jsx';
import {BigBoldBlueTextInline, EqualTwoTextInputs, MyView} from '@/styles';
import {styles} from '@/styles/common/styles.js';
import vars from '@/styles/root';
import {useTheme} from 'styled-components';
function ProgressCard(props) {
  const theme = useTheme();
  return (
    <MyView
      style={{
        ...styles.padding10,
        width: props.width,
      }}>
      <Pressable
        onPress={props.onPress}
        style={{
          ...styles.padding10,
          ...styles.boxShadow,
          ...styles.borderRadius10,
          backgroundColor: theme.colors.background.modal,
        }}>
        <MyView
          style={{
            ...styles.positionAbsolute,
            ...styles.top0,
            ...styles.right0,
            width: props.percent,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            height: '100%',
            backgroundColor: props.theme,
          }}
        />
        {props.header && (
          <EqualTwoTextInputs>
            <BigBoldBlueTextInline
              style={{
                color: props.color ? props.color : theme.colors.text.base,
                paddingRight: 30,
              }}
              text={props.header}
            />
            {props.circleText && (
              <Circle
                text={props.circleText}
                color={vars.WHITE}
                diameter={25}
                backgroundColor={theme.colors.text.base}
              />
            )}
          </EqualTwoTextInputs>
        )}
      </Pressable>
    </MyView>
  );
}
export default ProgressCard;
